// Hardcoded platform-level seed event.
// Time-based visibility is driven by the current US Eastern time.
//
// June 6, 2026 · 11:00 AM – 4:00 PM Eastern Time (EDT = UTC-4 in June)
//   Start: 11:00 AM EDT  =>  2026-06-06T15:00:00Z
//   End:    4:00 PM EDT  =>  2026-06-06T20:00:00Z

const START_UTC_MS = Date.UTC(2026, 5, 6, 15, 0, 0); // June (month index 5)
const END_UTC_MS = Date.UTC(2026, 5, 6, 20, 0, 0);

export const SEED_EVENT = {
  id: "platform-stauffer-2026-06-06",
  name: "8th Annual ODC Food Truck Fest at Stauffer Park",
  title: "8th Annual ODC Food Truck Fest at Stauffer Park",
  // ISO instant for the event start in UTC; formatters that show date are fine,
  // but we display the time as a hardcoded ET range to keep it canonical.
  event_date: new Date(START_UTC_MS).toISOString(),
  start_utc_ms: START_UTC_MS,
  end_utc_ms: END_UTC_MS,
  date_label: "Sat, Jun 6, 2026",
  time_range_label: "11:00 AM – 4:00 PM ET",
  location: "1241 Lititz Pike, Lancaster, PA",
  address: "1241 Lititz Pike, Lancaster, PA",
  lat: 40.0668,
  lng: -76.3203,
  is_platform_event: true,
  vendor_name: "FoodieFinder Events",
};

// Returns 'upcoming' | 'active' | 'ended'.
// Accepts an optional `nowMs` for testability.
export function getSeedEventStatus(nowMs) {
  const t = typeof nowMs === "number" ? nowMs : Date.now();
  if (t >= SEED_EVENT.end_utc_ms) return "ended";
  if (t >= SEED_EVENT.start_utc_ms) return "active";
  return "upcoming";
}

export function isSeedEventVisible(nowMs) {
  return getSeedEventStatus(nowMs) !== "ended";
}
